import { render, staticRenderFns } from "./IwsVideo.vue?vue&type=template&id=634b9601&scoped=true&"
import script from "./IwsVideo.vue?vue&type=script&lang=js&"
export * from "./IwsVideo.vue?vue&type=script&lang=js&"
import style0 from "./IwsVideo.vue?vue&type=style&index=0&id=634b9601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b9601",
  null
  
)

export default component.exports